import * as React from 'react';
import { useSelector } from 'react-redux';

import { useTheme } from '../../../../../theme';
import { getIsOpenedLastExchange } from '../../../../../Checkout/store/order/selectors';

import { getLastSelectedFlight } from '@entities/exchange';

import { useExchangeRouteControls } from '@features/exchange/exchange-route-controls';
import { useRefreshExchangeOrder } from '../../lib/useRefreshExchangeOrder';
import { ExchangeTicket } from '../ExchangeTicket';
import { ExchangeRequest } from '../ExchangeRequest';

const Request: React.FC = () => {
	const { Request: theme } = useTheme('Widgets').Exchange;

	const isOpenedLastExchange = useSelector(getIsOpenedLastExchange);
	const lastSelectedFlight = useSelector(getLastSelectedFlight);

	const exchangeRouteControls = useExchangeRouteControls();
	const refreshExchangeOrder = useRefreshExchangeOrder();

	const isNewRequest = lastSelectedFlight && !isOpenedLastExchange;

	return (
		<div className={theme.root}>
			{isNewRequest ? (
				<ExchangeRequest
					returnToOrder={exchangeRouteControls.onBackToOrder}
					reloadOrder={refreshExchangeOrder.onRefreshOrder}
				/>
			) : (
				<ExchangeTicket />
			)}
		</div>
	);
};

export default Request;
